import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useErrorTrackerContextSafe } from "@/contexts/ErrorTrackerContext";

// Map routes to functional modules
function getModuleFromPath(pathname: string): string {
  // Normalize pathname
  const path = pathname.toLowerCase();

  // Check specific routes first (most specific to least specific)
  if (path.startsWith("/greenhouse/") || path === "/blocks" || path === "/block-map") {
    return "block_map";
  }
  if (path.startsWith("/inventory")) {
    return "inventory";
  }
  if (path.startsWith("/spray-logs")) {
    return "spray_logs";
  }
  if (path.startsWith("/pests")) {
    return "pest_scouting";
  }
  if (path.startsWith("/planner")) {
    return "planner";
  }
  if (path.startsWith("/tasks")) {
    return "planner";
  }
  if (path.startsWith("/team") || path.startsWith("/teams")) {
    return "team";
  }
  if (path.startsWith("/settings")) {
    return "settings";
  }
  if (path.startsWith("/dashboard")) {
    return "dashboard";
  }
  if (path.startsWith("/consumption")) {
    return "inventory";
  }
  if (path.startsWith("/analytics") || path.startsWith("/reports")) {
    return "analytics";
  }
  if (path.startsWith("/shop")) {
    return "shop";
  }
  if (path.startsWith("/getting-started")) {
    return "onboarding";
  }
  if (path === "/" || path.startsWith("/auth") || path.startsWith("/register")) {
    return "public";
  }

  // Default fallback
  return "unknown";
}

export function NavigationTracker() {
  const location = useLocation();
  const context = useErrorTrackerContextSafe();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!context) return;

    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    // Only track if path actually changed
    if (currentPath !== previousPath) {
      const module = getModuleFromPath(currentPath);
      
      // Update current module
      context.setCurrentModule(module);
      
      // Track navigation action
      context.trackAction("navigate", currentPath, {
        from: previousPath || undefined,
        module,
      });

      previousPathRef.current = currentPath;
    }
  }, [location.pathname, context]);

  // This component doesn't render anything
  return null;
}
